<div [formGroup]="formLegalEntity" class=" mt-4 container mx-auto">
  <div class="flex justify-center items-center mt-3 mx-2 gap-x-7 w-12/12 ">
    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Código TG</mat-label>
        <input matInput readonly formControlName="codigoTG" />
      </mat-form-field>
    </div>
    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>OS</mat-label>
        <input matInput readonly formControlName="os" />
      </mat-form-field>
    </div>

    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Status</mat-label>
        <input matInput readonly formControlName="status" />
      </mat-form-field>
    </div>
  </div>
  <!--row one / row two -->
  <div class="flex justify-center items-center mt-3 mx-2 gap-x-7 w-12/12">
    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Cliente</mat-label>
        <input matInput formControlName="cliente" readonly />
      </mat-form-field>
    </div>

    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>SubCliente</mat-label>
        <input matInput formControlName="subCliente" readonly />
      </mat-form-field>
    </div>

    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Nome do Evento</mat-label>
        <input matInput formControlName="nomeEvento" readonly />
      </mat-form-field>
    </div>
  </div>
  <!--row two / row three -->
  <div class="flex justify-center items-center  mt-3 mx-2 gap-x-7 w-12/12">
    <!-- Consultor Comercial -->
    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Consultor Comercial</mat-label>
        <input matInput formControlName="consultorComercial" readonly />
      </mat-form-field>
    </div>


    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Consultor do Cliente</mat-label>
        <input matInput formControlName="consultorCliente" readonly />
      </mat-form-field>
    </div>

    <!-- Período -->

  </div>

  <!--row three / row four -->
  <div class="flex justify-center items-center mt-3 mx-2 gap-x-7 w-12/12">
    <!-- Tipo serviço -->
    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Tipo Serviço</mat-label>
        <input matInput formControlName="tipoServico" readonly />
      </mat-form-field>
    </div>

    <!-- Serviço -->
    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Serviço</mat-label>
        <input matInput formControlName="servico" readonly />
      </mat-form-field>
    </div>

    <!-- Fornecedor -->
    <!-- <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Fornecedor</mat-label>
        <input matInput formControlName="fornecedor" readonly />
      </mat-form-field>
    </div> -->
  </div>
  <!--row four / row five -->



  <div class="flex justify-center items-center mt-3 mx-2 gap-x-7 w-12/12">
    <!-- Tipo motorista -->
    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline">
        <mat-label>Tipo Veículo</mat-label>
        <input matInput readonly formControlName="vehicle" />

      </mat-form-field>
    </div>

    <!-- Motorista -->
    <div class="flex flex-col w-6/12">

      <mat-form-field class="input-tg w-12/12 px-2" appearance="outline">
        <mat-label>Tipo Motorista</mat-label>
        <input matInput readonly formControlName="typeDriver" />
      </mat-form-field>
    </div>
  </div>
  <!--row six / row seven -->
  <div class="flex justify-between items-center mt-3 mx-2 gap-x-3 w-12/12">
    <div class="flex flex-col w-3/12">
      <mat-form-field class="input-tg px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Quantidade de Passageiros</mat-label>
        <input matInput readonly formControlName="qtdPassageiros" />
      </mat-form-field>
    </div>



    <div class="flex justify-center items-center w-7/12 gap-4 mr-2">
      <mat-form-field class="input-tg w-1/4" appearance="outline" hideRequiredMarker>
        <mat-label>Hora Saída</mat-label>
        <input matInput formControlName="timeStart" type="time" />
      </mat-form-field>
      <mat-form-field class="input-tg w-1/4" appearance="outline" hideRequiredMarker>
        <mat-label>Hora Chegada</mat-label>
        <input matInput formControlName="timeFinal" type="time" />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12" appearance="outline" hideRequiredMarker>
        <mat-label class="text-sm text-gray-600 mb-1">Data Inicial</mat-label>
        <input matInput [matDatepicker]="start" formControlName="dateInitial" [max]="maxDate"
          placeholder="00/00/0000" />
        <mat-datepicker-toggle matIconSuffix [for]="start" [disabled]="true"></mat-datepicker-toggle>
        <mat-datepicker #start></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label class="text-sm text-gray-600 mb-1">Data Final</mat-label>
        <input matInput [matDatepicker]="end" formControlName="dateFinal" [max]="maxDate" placeholder="00/00/0000"
           />
        <mat-datepicker-toggle matIconSuffix [for]="end" [disabled]="true"></mat-datepicker-toggle>
        <mat-datepicker #end></mat-datepicker>
      </mat-form-field>

    </div>
  </div>

  <div class="flex justify-center items-center  mt-3 mx-2 gap-x-7 w-12/12">
    <mat-form-field class="input-tg w-full px-2" appearance="outline">
      <mat-label>Observação</mat-label>
      <textarea type="text" matInput formControlName="observation"></textarea>
    </mat-form-field>
  </div>




  <div class="flex justify-start items-center mt-3 mx-4 gap-x-5 w-12/12 ">
    <div class="flex flex-col w-2/12">
      <mat-form-field class="input-tg no-message-new" appearance="outline">
        <mat-label>Valor Tarifário</mat-label>
        @if (formLegalEntity.get('valueTariff')!.value != '') {
        <span matTextPrefix>R$&nbsp;</span>
        }
        <input matInput  formControlName="valueTariff" currencyInput />
      </mat-form-field>
    </div>
    <div class="flex flex-col w-2/12">

      <mat-form-field class="input-tg no-message-new" appearance="outline" hideRequiredMarker>
        <mat-label>Valor Proposta</mat-label>
        @if (formLegalEntity.get('valueProposal')!.value != '') {
        <span matTextPrefix>R$&nbsp;</span>
        }
        <input matInput  formControlName="valueProposal" />
      </mat-form-field>
    </div>

    <div class="flex flex-col w-2/12">

      <mat-form-field class="input-tg no-message-new" appearance="outline" hideRequiredMarker>
        <mat-label>Valor Compra</mat-label>
        @if (formLegalEntity.get('valueBuy')!.value != '') {
        <span matTextPrefix>R$&nbsp;</span>
        }
        <input matInput  formControlName="valueBuy" />
      </mat-form-field>
    </div>
  </div>


</div>

<!-- <div class="flex justify-end items-center  mt-3 mx-2 gap-x-7 w-12/12">
  <button mat-flat-button class="flex flex-row btn-tg" [disabled]="formLegalEntity.invalid || loading"
    (click)="pushdates()">
    @if(loading){
    <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
    }@else{
    Definir
    }
  </button>
</div> -->
